export default __webpack_public_path__ + "static/media/msf_l1.9b3ce5ee.png";